type BudgetRingProps = {
	remaining: number;
	className?: string;
	shake?: boolean;
};

const R = 44;
const C = 2 * Math.PI * R;

export function BudgetRing({ remaining, className = "", shake }: BudgetRingProps) {
	const clamped = Math.max(0, Math.min(100, remaining));
	const goldLen = (clamped / 100) * C;
	const gapLen = C - goldLen;

	return (
		<div className={`relative flex flex-col items-center ${shake ? "animate-app-shake" : ""} ${className}`}>
			<svg width="112" height="112" viewBox="0 0 112 112" className="text-wi-gold" aria-hidden>
				<circle cx="56" cy="56" r={R} fill="none" stroke="currentColor" strokeWidth="6" opacity="0.12" />
				<circle
					cx="56"
					cy="56"
					r={R}
					fill="none"
					stroke="currentColor"
					strokeWidth="6"
					strokeLinecap="round"
					strokeDasharray={`${goldLen} ${gapLen}`}
					transform="rotate(-90 56 56)"
					className="transition-[stroke-dasharray] duration-300 ease-out"
				/>
			</svg>
			<span className="absolute inset-0 flex items-center justify-center pt-1 font-display text-wi-text text-xl tracking-tight">
				{clamped}
			</span>
			<span className="mt-1 text-center text-wi-text/55 text-xs">points left (Σv² ≤ 100)</span>
		</div>
	);
}
